import React from 'react';

// Official KeyPubli logo (optimised WebP with PNG fallback, 2x for sharp screens)
export const BrandLogo = ({ className = 'h-9' }) => (
  <picture>
    <source srcSet="/keypubli-logo.webp" type="image/webp" />
    <img src="/keypubli-logo.png" alt="KeyPubli" className={`${className} w-auto select-none`} width="332" height="96" decoding="async" data-testid="brand-logo" />
  </picture>
);

export default BrandLogo;
